import styles from "./SelectAllItems.module.scss";
import { FILTERS_SELECT_ALL_ITEMS_TESTID } from "@/constants/test-ids";
import { useEffect, useRef, useState } from "react";
import { DEFAULT_FILTER_KEY } from "@/constants";
import { TreeService } from "@/services";
import { IPanelScope, ITreeItem } from "@/interfaces";
import { getActiveItemFromUrl, getTranslation } from "@/utils";
import { PanelSettings } from "@/types";

interface SelectAllItemsProps {
  onAllSelected: (node: any) => void;
  module: string;
  selectedItem: ITreeItem | null;
  contextMenu: any;
  scope: IPanelScope;
  settings: PanelSettings;
}

export const SelectAllItems = ({
  scope,
  contextMenu,
  onAllSelected,
  module,
  selectedItem,
  settings,
}: SelectAllItemsProps) => {
  const [isHover, setIsHover] = useState<boolean>();
  const selectAllRef = useRef<HTMLDivElement>(null);
  const initRef = useRef<boolean>(true);
  const activeUrlFormUrl = getActiveItemFromUrl(scope);
  const moduleDisplayName = TreeService.getModuleDisplayName(module);

  const isSelected =
    activeUrlFormUrl === DEFAULT_FILTER_KEY ||
    selectedItem?.id === DEFAULT_FILTER_KEY;

  useEffect(() => {
    if (initRef.current && isSelected) {
      initRef.current = false;
      selectAllRef.current?.click();
    }
  }, [selectAllRef.current]);

  const resetSelectedFilter = () => {
    onAllSelected({ id: DEFAULT_FILTER_KEY });
  };

  const getContextMenu = () => {
    if (!isHover) {
      return null;
    }
    return contextMenu({
      isSelected,
      data: { key: DEFAULT_FILTER_KEY, id: DEFAULT_FILTER_KEY },
    });
  };

  return (
    <div
      ref={selectAllRef}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      className={`${styles.defaultFilter} ${isSelected ? styles.selected : ""}`}
      role="presentation"
      data-testid={FILTERS_SELECT_ALL_ITEMS_TESTID}
    >
      <span
        tabIndex={0}
        role="button"
        style={{ display: "flex", flexGrow: 1 }}
        onClick={resetSelectedFilter}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            resetSelectedFilter();
          }
        }}
      >
        {getTranslation(`${module.toLowerCase()}.grid.all`, moduleDisplayName)}
      </span>
      {settings?.enableSettings && getContextMenu()}
    </div>
  );
};
